/**
REGS:
IS.I/D.OR.240
Organisational structure

IS.I/D.OR.200(a)(1)
Information security policy

IS.I/D.OR.255
Change management

IS.I/D.OR.235
Contracted Information Security management activities

IS.I/D.OR.205(a) and (b)
Scope of the ISMS

IS.I/D.OR.205 and 210
Risk management

IS.I/D.OR.220
Incident management (Detect, Respond, Recover)

IS.I/D.OR.215 and 230
Internal and External Reporting

IS.I/D.OR.245
Record keeping

IS.I/D.OR.200(a)(6) and (a)(7)
Measures and findings notified by the competent authority

IS.I/D.OR.200(a)(13)
Protection of the confidentiality of information received from other org’s

IS.I/D.OR.200(a)(12)
Monitoring of compliance with Part-IS requirements
 */

const regulatoryRequirementsDropdownData = [{
    "label": "Organisational Structure",
    "id": "Organisational Structure",
    "metadata": {
        "number": "IS.I/D.OR.240"
    }
}, {
    "label": "Information Security Policy",
    "id": "Information Security Policy",
    "metadata": {
        "number": "IS.I/D.OR.200(a)(1)"
    }
}, {
    "label": "Change Management",
    "id": "Change Management",
    "metadata": {
        "number": "IS.I/D.OR.255"
    }
}, {
    "label": "Contracted Information Security Management Activities",
    "id": "Contracted Information Security Management Activities",
    "metadata": {
        "number": "IS.I/D.OR.235"
    }
}, {
    "label": "Scope of the ISMS",
    "id": "Scope of the ISMS",
    "metadata": {
        "number": "IS.I/D.OR.205(a) and (b)"
    }
}, {
    "label": "Risk Management",
    "id": "Risk Management",
    "metadata": {
        "number": "IS.I/D.OR.205 and 210"
    }
}, {
    "label": "Incident Management (Detect, Respond, Recover)",
    "id": "Incident Management (Detect, Respond, Recover)",
    "metadata": {
        "number": "IS.I/D.OR.220"
    }
}, {
    "label": "Internal and External Reporting",
    "id": "Internal and External Reporting",
    "metadata": {
        "number": "IS.I/D.OR.215 and 230"
    }
}, {
    "label": "Record Keeping",
    "id": "Record Keeping",
    "metadata": {
        "number": "IS.I/D.OR.245"
    }
}, {
    "label": "Measures and findings notified by the competent authority",
    "id": "Measures and findings notified by the competent authority",
    "metadata": {
        "number": "IS.I/D.OR.200(a)(6) and (a)(7)"
    }
}, {
    "label": "Protection of the confidentiality of information received from other org’s",
    "id": "Protection of the confidentiality of information received from other org’s",
    "metadata": {
        "number": "IS.I/D.OR.200(a)(13)"
    }
}, {
    "label": "Monitoring of compliance with Part-IS requirements",
    "id": "Monitoring of compliance with Part-IS requirements",
    "metadata": {
        "number": "IS.I/D.OR.200(a)(12)"
    }
}];


export function addRegulatoryRequirement({ form }) {
    form.setConfig({
        "title": "Add Regulatory Requirement",
        "type": "push",
        "location": "SafetyManagement/InformationSafetyManager/RegulatoryRequirements/",
        "fields": [{
            "label": "Regulatory Requirement",
            "name": "RegulatoryRequirement",
            "type": "dropdown",
            "dropdownData": regulatoryRequirementsDropdownData
        }, {
            "label": "Element",
            "name": "Element",
            "type": "text",
            "divClass": "col-span-2"
        }, {
            "label": "ISMM",
            "name": "ISMM",
            "type": "checkbox"
        }, {
            "label": "Auditable",
            "name": "Auditable",
            "type": "checkbox"
        }],
        preSubmitHook({ data  }) {
            const selectedDropdown = regulatoryRequirementsDropdownData.find(d => d.id === data.RegulatoryRequirement);
            return {
                "RegulatoryRequirementNumber": selectedDropdown.metadata.number,
                "ISMM": data.ISMM ? "Pending" : "Not Required",
                "Auditable": data.Auditable ? "Pending" : "Not Required",
                "SafetyManager": "Pending",
                "EASA": "Pending",
                "Date": {
                    "Added": new Date().toISOString(),
                    "Updated": new Date().toISOString(),
                    "ISMM": data.ISMM ? "Pending" : "Not Required",
                    "Auditable": data.Auditable ? "Pending" : "Not Required",
                    "SafetyManager": "Pending",
                    "EASA": "Pending"
                }
            }
        }
    });
    form.getDropdownData();
    form.toggle();
};

export function editRegulatoryRequirement({ form, pageItem }) {
    form.setValues(pageItem);
    form.setConfig({
        "title": "Edit Regulatory Requirement",
        "type": "update",
        "location": `SafetyManagement/InformationSafetyManager/RegulatoryRequirements/${pageItem.ID}`,
        "fields": [{
            "label": "Regulatory Requirement",
            "name": "RegulatoryRequirement",
            "type": "dropdown",
            "dropdownData": regulatoryRequirementsDropdownData
        }, {
            "label": "Element",
            "name": "Element",
            "type": "text",
            "divClass": "col-span-2"
        }, {
            "label": "ISMM",
            "name": "ISMM",
            "type": "checkbox"
        }, {
            "label": "Auditable",
            "name": "Auditable",
            "type": "checkbox"
        }],
        preSubmitHook({ data }) {
            const selectedDropdown = regulatoryRequirementsDropdownData.find(d => d.id === data.RegulatoryRequirement);
            return {
                "RegulatoryRequirementNumber": selectedDropdown.metadata.number,
            }
        }
    });
    form.getDropdownData();
    form.toggle();
};

const reviewDecisionDropdown = [{
    "label": "Complete",
    "id": "Complete"
}, {
    "label": "Additional Information Required",
    "id": "Additional Information Required",
}];

export const review = (type) => ({ form, pageItem }) => {
    form.setValues(pageItem);
    form.setConfig({
        "title": `${type} Review for ${pageItem.RegulatoryRequirement}`,
        "type": "update",
        "description": pageItem.Element,
        "location": `SafetyManagement/InformationSafetyManager/RegulatoryRequirements/${pageItem.ID}`,
        "fields": [{
            "label": "Decision",
            "type": "dropdown",
            "name": type,
            "dropdownData": reviewDecisionDropdown
        }, {
            "label": "Comments",
            "type": "richtext",
            "name": `${type}Comments`,
            "divClass": "md:col-span-3"
        }],
        preSubmitHook(){
            return {
                "Date": {
                    [type]: new Date().toISOString()
                }
            }
        }
    });
    form.getDropdownData();
    form.toggle();
};


